import React from 'react';
import PropTypes from 'prop-types';

const GifComponent = function GifComponent({
  gifUrl,
  width = '50px',
  height = '50px',
}) {
  return <img src={gifUrl} alt="gif" width={width} height={height} />;
};

GifComponent.propTypes = {
  gifUrl: PropTypes.node.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default GifComponent;
